export default "__VITE_ASSET__BJ9A7oMw__"